import React from 'react';
import { ButtonContainer, ButtonText, ButtonIcon } from './Button.styles';

const Button = ({ 
  children, 
  variant = 'primary', 
  size = 'medium', 
  icon, 
  onClick, 
  disabled = false,
  fullWidth = false,
  ...props 
}) => {
  return (
    <ButtonContainer
      variant={variant}
      size={size}
      fullWidth={fullWidth}
      disabled={disabled}
      onClick={onClick}
      {...props}
    >
      {icon && <ButtonIcon>{icon}</ButtonIcon>}
      <ButtonText>{children}</ButtonText>
    </ButtonContainer>
  );
};

export default Button;